(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Get the main outer header section container
      this.header = document.querySelector('.section-header');
      
      // Set initial height dimensions for CSS references
      this.setHeaderHeight();

      // Listen for viewport changes (desktop/mobile layout shifts) to update heights
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Make the header sticky immediately when sticky-header component is rendered
      this.header.classList.add('shopify-section-header-sticky');

      // Bind the scroll event handler
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      
      // Call scroll handler once immediately to set the correct state on initial page load
      this.onScroll();
    }

    // Measure the header and announcement bar heights and expose them to CSS as custom variables.
    // This allows elements like hero banners to align correctly beneath a transparent/sticky header.
    setHeaderHeight() {
      // Expose header height
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      
      // Expose announcement bar height if it exists on the page
      const announcementBar = document.querySelector('.announcement-bar-section');
      const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
    }

    disconnectedCallback() {
      // Clean up the event listener when element is removed from the DOM
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Toggle 'scrolled-past-header' class based on whether the page has been scrolled.
      // This class triggers the CSS transition from transparent to solid background color
      // when the header is overlaying a first-child hero banner.
      if (scrollTop > 0) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Prestige-Style Mega Menu Hover and Overlay Logic */
  document.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia('(min-width: 990px)').matches) {
      const detailsElements = document.querySelectorAll('header-menu > details');
      const overlay = document.querySelector('.mega-menu-overlay');
      const headerWrapper = document.querySelector('.header-wrapper');

      detailsElements.forEach(details => {
        let timeoutId;

        details.addEventListener('mouseenter', () => {
          clearTimeout(timeoutId);
          detailsElements.forEach(other => {
            if (other !== details) other.removeAttribute('open');
          });
          details.setAttribute('open', '');
          if (overlay) overlay.classList.add('is-active');
        });

        details.addEventListener('mouseleave', () => {
          timeoutId = setTimeout(() => {
            details.removeAttribute('open');
            const anyOpen = Array.from(detailsElements).some(d => d.hasAttribute('open'));
            if (!anyOpen && overlay) overlay.classList.remove('is-active');
          }, 150);
        });
      });

      if (headerWrapper) {
        headerWrapper.addEventListener('mouseleave', () => {
          detailsElements.forEach(details => details.removeAttribute('open'));
          if (overlay) overlay.classList.remove('is-active');
        });
      }

      /* Collections mega menu — image crossfade on row hover */
      document.querySelectorAll('.mega-menu--collections').forEach(menu => {
        const imgA = menu.querySelector('.mega-menu__coll-img--a');
        const imgB = menu.querySelector('.mega-menu__coll-img--b');
        const items = menu.querySelectorAll('.mega-menu__coll-item[data-featured-src]');
        if (!imgA || !imgB || !items.length) return;

        let currentSrc = '';
        let crossfadeTimer = null;

        menu.addEventListener('toggle', () => {
          if (menu.hasAttribute('open') && items.length) {
            const first = items[0];
            imgA.src = first.dataset.featuredSrc;
            imgA.alt = first.dataset.featuredAlt || '';
            currentSrc = imgA.src;
          }
        });

        items.forEach(item => {
          item.addEventListener('mouseenter', () => {
            const src = item.dataset.featuredSrc;
            if (!src || src === currentSrc) return;
            clearTimeout(crossfadeTimer);

            imgB.src = src;
            imgB.alt = item.dataset.featuredAlt || '';

            requestAnimationFrame(() => {
              imgA.classList.add('is-fading');
              imgB.classList.add('is-visible');
              crossfadeTimer = setTimeout(() => {
                imgA.src = src;
                imgA.alt = imgB.alt;
                imgA.classList.remove('is-fading');
                imgB.classList.remove('is-visible');
                currentSrc = src;
              }, 460);
            });
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
